import React from 'react';
import PropTypes from 'prop-types';

import './SubmitAnnotationField.css';

const SubmitAnnotationField = ({ isSubmittable, onSubmit, onCancel }) => (
  <div className="annotator-buttons">
    <button type="button" className="cancel-btn btn" onClick={onCancel}>
      Cancel
    </button>
    <button type="button" className="save-btn btn" onClick={onSubmit} disabled={!isSubmittable}>
      Save
    </button>
  </div>
);

SubmitAnnotationField.propTypes = {
  isSubmittable: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

SubmitAnnotationField.defaultProps = {
  isSubmittable: true,
};

export default SubmitAnnotationField;
